'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dFeature$002dCode$0024 from "./presto.types$-Feature-Code$.js";
var $p;
/** @constructor */
function $c_Lpresto_DangerAlert$$anon$8() {
  this.aII = null;
  this.aIG = null;
  this.aIH = false;
  this.aIE = null;
  this.aIF = false;
  this.aIJ = false;
  this.aIK = false;
  this.aII = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_DangerAlert$$anon$8 as $c_Lpresto_DangerAlert$$anon$8 };
$p = $c_Lpresto_DangerAlert$$anon$8.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_DangerAlert$$anon$8;
/** @constructor */
function $h_Lpresto_DangerAlert$$anon$8() {
}
export { $h_Lpresto_DangerAlert$$anon$8 as $h_Lpresto_DangerAlert$$anon$8 };
$h_Lpresto_DangerAlert$$anon$8.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.aII;
});
$p.t = (function() {
  if ((!this.aIH)) {
    this.aIG = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("value", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aIH = true;
  }
  return this.aIG;
});
$p.ae = (function() {
  if ((!this.aIF)) {
    this.aIE = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dFeature$002dCode$0024.$m_Lpresto_types$FeatureCode$().cI3(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$24($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().j0), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aIF = true;
  }
  return this.aIE;
});
$p.w = (function() {
  if ((!this.aIK)) {
    this.aIJ = false;
    this.aIK = true;
  }
  return this.aIJ;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_DangerAlert$$anon$8 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_DangerAlert$$anon$8, "presto.DangerAlert$$anon$8", ({
  Gm: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_DangerAlert$$anon$8 as $d_Lpresto_DangerAlert$$anon$8 };
//# sourceMappingURL=presto.-Danger-Alert$$anon$8.js.map
